import { round } from "./state.js";
import { MAX_TRIES } from "./hint.js";
import { fmt, escapeHtml } from "./util.js";
import { shareResult } from "./share.js";

const modalEl = document.getElementById("modal");
const modalBody = document.getElementById("modalBody");

export function closeModal() { modalEl.classList.remove("open"); }

function ordinal(n) {
  const s = ['th', 'st', 'nd', 'rd'];
  const v = n % 100;
  return n.toLocaleString() + (s[(v - 20) % 10] || s[v] || s[0]);
}

export function openModal() {
  if (!round.item || !round.done) return;
  const { item, guesses, won } = round;
  const actual = item.amount;
  const best = guesses.reduce((b, g) => Math.abs(g.guess - actual) < Math.abs(b - actual) ? g.guess : b, Infinity);
  const bestDiff = best !== Infinity ? Math.abs(best - actual) : null;
  const bestPct = (bestDiff !== null && actual > 0) ? (bestDiff / actual) * 100 : null;
  const cur = item.currency || "$";
  const stats = round.stats;
  const communityHtml = stats && stats.total > 0
    ? `<div class="modal-community">
        <div class="mc-stat">
          <span class="mc-val">${ordinal(stats.total)}</span>
          <span class="mc-label">player on this item</span>
        </div>
        <div class="mc-divider"></div>
        <div class="mc-stat">
          <span class="mc-val">${Math.round((stats.correct / stats.total) * 100)}%</span>
          <span class="mc-label">community win rate</span>
        </div>
      </div>`
    : "";

  modalBody.innerHTML = `
    <h2 class="modal-headline ${won ? "win" : "lose"}">${won ? "You got it!" : "Out of guesses"}</h2>
    <div class="modal-subline">${won
      ? `Solved in ${guesses.length} ${guesses.length === 1 ? "try" : "tries"}`
      : `Better luck next round`}</div>
    <div class="modal-image"><img src="${(round.images && round.images[round.activeImg || 0]) || item.imgUrl}" alt="" referrerpolicy="no-referrer" /></div>
    <p class="modal-title-ellipsis">${escapeHtml(item.title)}</p>
    ${communityHtml}
    <dl class="modal-stats">
      <dt>Listing price</dt><dd class="big">${fmt(actual, cur)}</dd>
      <dt>Your best guess</dt><dd>${best !== Infinity ? fmt(best, cur) : "—"}</dd>
      <dt>Off by</dt><dd>${bestDiff !== null ? `${fmt(bestDiff, cur)}${bestPct !== null ? ` (${bestPct.toFixed(1)}%)` : ""}` : "—"}</dd>
      <dt>Guesses used</dt><dd>${guesses.length} / ${MAX_TRIES}</dd>
    </dl>
    <div class="modal-actions">
      <a class="ebay-btn" href="${item.link}" target="_blank" rel="noopener">
        <img src="/ebaylogo.svg" alt="eBay" />
        Find on eBay
      </a>
      <button class="push-btn" id="modalShare" type="button">Share</button>
      <button class="aqua-btn" id="modalNext" type="button">Next Item</button>
    </div>
  `;
  modalEl.classList.add("open");
  const nextBtn = document.getElementById("modalNext");
  nextBtn.addEventListener("click", () => { closeModal(); modalEl.dispatchEvent(new CustomEvent("next-item")); });
  document.getElementById("modalShare").addEventListener("click", shareResult);
  nextBtn.focus();
}

export function initModal() {
  document.getElementById("modalClose").addEventListener("click", () => {
    closeModal();
    modalEl.dispatchEvent(new CustomEvent("next-item"));
  });
  modalEl.addEventListener("click", (e) => {
    if (e.target === modalEl) {
      closeModal();
      modalEl.dispatchEvent(new CustomEvent("next-item"));
    }
  });
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && modalEl.classList.contains("open")) closeModal();
  });
}

export function onNextItem(fn) {
  modalEl.addEventListener("next-item", fn);
}
